// System
import { Select } from '@mui/material';
import { useMemo } from 'react';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';
import { useGeneral } from '@Modal/hooks/general/useGeneral';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

const RgsDropdown = () => {
  const { handleRgsChange, rgs } = useGeneral();
  const { currentUser } = useAuthorization();

  const rgsForAdmin = ['EU', 'SA', 'AS', 'AS1'];
  const isSuper = currentUser?.isSuper;
  const userRgsIds = currentUser?.rgsIds || [];

  const dropdownConfig = useMemo(() => {
    const options = isSuper ? rgsForAdmin : userRgsIds;
    const shouldShowSelect = isSuper || userRgsIds.length > 1;
    const currentRgs = rgs;

    return {
      options,
      shouldShowSelect,
      currentRgs,
    };
  }, [rgs, isSuper, userRgsIds, rgsForAdmin]);

  if (!dropdownConfig.shouldShowSelect) return null;

  return (
    <Select
      sx={{
        width: '86px',
        height: '32px',
      }}
      value={dropdownConfig.currentRgs}
      onChange={(event) => handleRgsChange(event.target.value as 'EU' | 'AS' | 'AS1' | 'SA')}
    >
      {dropdownConfig.options.map((region) => (
        <MenuItemEx key={region} name={region} value={region}>
          {region}
        </MenuItemEx>
      ))}
    </Select>
  );
};

export default RgsDropdown;
